const deliveryDetailsFields = {
    deliveryOption: 'deliveryOption',
    house: 'house',
    street: 'street',
    town: 'town',
    postcode: 'postcode'
};

export default deliveryDetailsFields;